import HeroHeaderSection from '../../../../components/ui-component/hero-header/HeroHeader';
import titleImage from '../../../../assets/images/programm/ProgrammTitle.png';

import { useFetchFoerderProgramm } from '../../../../hooks/FetchFoerderProgramm';
import React, { FC, useState } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import FoerderProgrammList from './structure/FoerderProgrammList';
import FoerderProgrammGrid from './structure/FoerdProgrammGrid';
// import { get } from "lodash";
// import SearchForm from '../../../components/ui-component/foerderProgramm/SearchForm';

import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';

const FoerderProgrammeView: FC = () => {
	const [programmView, setProgrammView] = useState<string>('grid');
	// const [filter, setFilter] = useState<object>({});
	// const [matchingFundings, setMatchingFundings] = useState<T[]>([]);

	const { loading, data, error } = useFetchFoerderProgramm();

	const updateProgramView = () => {
		setProgrammView((prevValue) => (prevValue === 'list' ? 'grid' : 'list'));
	};

	// useEffect(() => {
	// 	let matches: T[] = data;
	// 	console.log({ filter });
	// 	//Technologiebereiche filtern
	// 	let technologiebereiche = get(filter, "Technologiebereiche", []);
	// 	if (technologiebereiche.length > 0) {
	// 		matches = matches.filter((data) => {
	// 			let foTechnologiebereiche = get(data, "attributes.repeatable.Technologiebereiche", []);
	// 			console.log({ foTechnologiebereiche });
	// 			for (let technologiebereich of technologiebereiche) {
	// 				if (foTechnologiebereiche.includes(technologiebereich)) return true;
	// 			}
	// 			return false;
	// 		});
	// 	}
	// 	//Vorhabenarten filtern
	// 	let arten = get(filter, "Arten", []);
	// 	if (arten.length > 0) {
	// 		matches = matches.filter((data) => {
	// 			let foArt = get(data, "attributes.additional.Art");
	// 			return arten.includes(foArt);
	// 		});
	// 	}
	// 	//Förderhöhe filtern
	// 	let forderhohe = get(filter, "Förderhöhe");
	// 	let low = 0;
	// 	let high = Infinity;
	// 	switch (forderhohe) {
	// 		case "< 50.000€":
	// 			high = 50000;
	// 			break;
	// 		case "50.000€ - 100.000€":
	// 			low = 50000;
	// 			high = 100000;
	// 			break;
	// 		case "100.000€ - 500.000€":
	// 			low = 100000;
	// 			high = 500000;
	// 			break;
	// 		case "500.000€ - 1.000.000€":
	// 			low = 500000;
	// 			high = 1000000;
	// 			break;
	// 		case "> 1.000.000€":
	// 			low = 1000001;
	// 			break;
	// 		default:
	// 			low = 0;
	// 			high = Infinity;
	// 			break;
	// 	}
	// 	matches = matches.filter((match) => {
	// 		console.log(parseInt(get(match, "attributes.additional.maxBudgetPerYear", "").replace(/\./g, "")));
	// 		return parseInt(get(match, "attributes.additional.maxBudgetPerYear", "").replace(/\./g, "")) >= low;
	// 	});

	// 	//Dauer filtern
	// 	let Dauer = get(filter, "Laufzeit");
	// 	let number = 0;
	// 	switch (Dauer) {
	// 		case "< 1 Jahr":
	// 			number = 0;
	// 			break;
	// 		case "1 Jahr":
	// 			number = 1;
	// 			break;
	// 		case "2 Jahre":
	// 			number = 2;
	// 			break;
	// 		case "3 Jahre":
	// 			number = 3;
	// 			break;
	// 		case "4 Jahre":
	// 			number = 4;
	// 			break;
	// 		case "5 Jahre":
	// 			number = 5;
	// 			break;
	// 		case "> 5 Jahre":
	// 			number = Infinity;
	// 			break;
	// 		default:
	// 			number = 0;
	// 			break;
	// 	}
	// 	matches = matches.filter((match) =>
	// 		get(match, "attributes.additional.maxDurationYears")
	// 			? parseInt(get(match, "attributes.additional.maxDurationYears")) >= number
	// 			: true,
	// 	);
	// 	console.log({ filter });
	// 	if (
	// 		get(filter, "Arten", []).length === 0 ||
	// 		!get(filter, "Förderhöhe") ||
	// 		!get(filter, "Laufzeit") ||
	// 		get(filter, "Technologiebereiche", []).length === 0
	// 	) {
	// 		matches = [];
	// 	}

	// 	// if (setResults) setResults(matches);
	// 	setMatchingFundings(matches);
	// }, [filter, data]);

	if (error) console.error('ERROR: Fetching Programm ', error);

	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<HeroHeaderSection
				title="Übersicht der Förderangebote"
				description="Dies ist ein Beispieltext, der als Platzhalter dient."
				backgroundImage={titleImage}
			/>
			<Container>
				{/* <SearchForm filter={filter} setFilter={setFilter} Technologiebereiche={[]} Arten={[]} /> */}

				<ProgramTitleSection {...{ dataLength: data?.length, programmView, updateProgramView }} />

				<Box sx={{ mt: '2rem' }}>
					{programmView === 'list' ? <FoerderProgrammList {...{ data }} /> : <FoerderProgrammGrid {...{ data }} />}
				</Box>
			</Container>
		</>
	);
};

const ProgramTitleSection: FC<{ dataLength: number | undefined; programmView: string; updateProgramView: () => void }> = ({
	dataLength,
	programmView,
	updateProgramView,
}) => {
	console.log({ programmView, updateProgramView });
	return (
		<>
			<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'}>
				<Typography variant="h5"> {dataLength} Förderangebote </Typography>
			</Stack>
		</>
	);
};

export default FoerderProgrammeView;
